import type { UseQueryResult } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { ErrorPanel } from './ErrorPanel';
import { SectionSkeleton } from './SectionSkeleton';

export function SectionQuery<T>({
  query,
  loadingLabel,
  children,
}: {
  query: UseQueryResult<T>;
  loadingLabel: string;
  children: (data: T) => ReactNode;
}) {
  if (query.isPending) return <SectionSkeleton label={loadingLabel} />;
  if (query.isError) {
    return (
      <div className="mx-auto w-full max-w-md">
        <ErrorPanel
          title="We couldn’t load this section"
          message="Your connection may have dropped, or the portal may be temporarily unavailable."
          onRetry={() => void query.refetch()}
          retrying={query.isFetching}
        />
      </div>
    );
  }
  return children(query.data);
}
